// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.turing-ui-v2-techleadnextstack-modal {
    width: 504px;
    height: 428px;
}

.turing-ui-v2-techleadnextstack-modal-pluspoint {
    margin: auto;
    width: 426px;
    height: 38px;
    
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: #212121;
    margin-bottom: 32px;
}

.turing-ui-v2-techleadnextstack-modal-congratulation-text {
    width: 414px;
    margin: auto;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 26.62px;
    text-align: center;
    color: #212121;
    margin-bottom: 16px;
}

.turing-ui-v2-techleadnextstack-modal {

    width: 504px;
    height: 421px;
    border-radius: 6px;
}



.turing-ui-v2-techleadnextstack-tests-list-container {
    display: flex;
    flex-wrap: wrap;
    width: 441px;
    gap: 26px;
    margin-left: 23px;
    max-height: 220px;
    overflow-y: auto;
}

.turing-ui-v2-techleadnextstack-tests-list-testicon {
    width: 46px;
    height: 46px;
    margin-left: 10px;
}

.turing-ui-v2-techleadnextstack-tests-list {
    display: flex;
    height: 96px;
    width: 201px;
    border-radius: 4px;
    align-items: center;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    box-sizing: border-box;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    cursor: pointer;
}

.turing-ui-v2-techleadnextstack-tests-list-challenge-name-duration {
    
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    width: 50px;
    height: 19px;
    color: #AAAAAA;
}

.turing-ui-v2-techleadnextstack-tests-list-challenge-next {
    color: #CCCCCC
}

.turing-ui-v2-techleadnextstack-tests-list-challenge-name {

    height: 42px;
    width: 97px;
    margin-left: 15px;
    display: inline-block;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
    color: #212121;
}

.turing-ui-v2-techleadnextstack-tests-list-challenge-name p {

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 0;
}

.turing-ui-v2-techleadnextstack-modal-container {
    margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/tests/Modals/TechLeadNextStack.model.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;;IAEZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;;;AAIA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,2CAA2C;IAC3C,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;;IAEI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;IAEI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".turing-ui-v2-techleadnextstack-modal {\n    width: 504px;\n    height: 428px;\n}\n\n.turing-ui-v2-techleadnextstack-modal-pluspoint {\n    margin: auto;\n    width: 426px;\n    height: 38px;\n    \n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 19px;\n    color: #212121;\n    margin-bottom: 32px;\n}\n\n.turing-ui-v2-techleadnextstack-modal-congratulation-text {\n    width: 414px;\n    margin: auto;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 26.62px;\n    text-align: center;\n    color: #212121;\n    margin-bottom: 16px;\n}\n\n.turing-ui-v2-techleadnextstack-modal {\n\n    width: 504px;\n    height: 421px;\n    border-radius: 6px;\n}\n\n\n\n.turing-ui-v2-techleadnextstack-tests-list-container {\n    display: flex;\n    flex-wrap: wrap;\n    width: 441px;\n    gap: 26px;\n    margin-left: 23px;\n    max-height: 220px;\n    overflow-y: auto;\n}\n\n.turing-ui-v2-techleadnextstack-tests-list-testicon {\n    width: 46px;\n    height: 46px;\n    margin-left: 10px;\n}\n\n.turing-ui-v2-techleadnextstack-tests-list {\n    display: flex;\n    height: 96px;\n    width: 201px;\n    border-radius: 4px;\n    align-items: center;\n    background: #FFFFFF;\n    border: 1px solid #DDDDDD;\n    box-sizing: border-box;\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.turing-ui-v2-techleadnextstack-tests-list-challenge-name-duration {\n    \n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 19px;\n    width: 50px;\n    height: 19px;\n    color: #AAAAAA;\n}\n\n.turing-ui-v2-techleadnextstack-tests-list-challenge-next {\n    color: #CCCCCC\n}\n\n.turing-ui-v2-techleadnextstack-tests-list-challenge-name {\n\n    height: 42px;\n    width: 97px;\n    margin-left: 15px;\n    display: inline-block;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 21px;\n    color: #212121;\n}\n\n.turing-ui-v2-techleadnextstack-tests-list-challenge-name p {\n\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    margin-bottom: 0;\n}\n\n.turing-ui-v2-techleadnextstack-modal-container {\n    margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
